var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "el-dialog3",
          attrs: {
            title: "机构管理员账号（手机号）更改密码",
            visible: _vm.dialogVisible,
            width: "25%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "line1Box" },
            [
              _c("p", { staticClass: "p1" }, [
                _c("span", [_vm._v("*")]),
                _vm._v("旧登录密码"),
              ]),
              _c("el-input", {
                staticStyle: { width: "2rem" },
                attrs: { size: "small", placeholder: "验证旧密码" },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "line1Box" },
            [
              _c("p", { staticClass: "p1" }, [_vm._v("新登录密码")]),
              _c("el-input", {
                staticStyle: { width: "2rem" },
                attrs: { size: "small", placeholder: "请设置新密码" },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "line1Box" },
            [
              _c("p", { staticClass: "p1" }, [_vm._v("再次输入登录密码")]),
              _c("el-input", {
                staticStyle: { width: "2rem" },
                attrs: { size: "small", placeholder: "请再次输入新密码" },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btns4",
                  attrs: { plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("确定更换密码")]
              ),
              _c(
                "p",
                { staticStyle: { "font-size": "0.12rem", color: "#424E5B" } },
                [_vm._v("忘记密码")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }